<template>
    <div class="container">
        <div class="section-space"></div>
        <div class="section-space"></div>
        <div class="section-space"></div>

        <div class="ticket-tt rounded p-4 bg-light">
            <span class="cut1"></span>
            <span class="cut2"></span>
            <div class="row">
                <div class="col-md-9">
                    <div class="row">
                        <div class="col-md-4 pr-0">
                            <img src="@/assets/img/poster3.png" width="190" height="auto" class="rounded">
                        </div>

                        <div class="col-md-8 pl-0">
                            <h4 class="pt-4">Simmba (U/A)</h4>

                            <p class="text-gray pt-3 mb-0">
                                PVR ICON: Oberoi Mall, Goregaon (E) (AUDI 01),<br>
                                Mumbai, Mumbai: Western <br> 10:55pm | Sat, 12 Jan, 2019
                            </p>
                            <h5>Quantity: 3</h5>
                            <div class="d-flex align-items-center">
                                <img src="@/assets/img/armchair.svg" class="img-fluid" width="35" height="auto">
                                <div class="ml-2">
                                    <p class="seat-no mb-0">PRIME - J19, J20, J21</p>
                                    <p class="mb-0 text-gray">AUDI 01</p>
                                </div>
                            </div>
                             <div class="border-dash mt-4">
                                 <div class="d-flex float-left align-items-center mt-2">
                                     <!-- <img src="@/assets/img/plus.svg" width="25"> -->
                                     <span class="text-gray pl-2">AMOUNT PAID</span>
                                 </div>

                                 <div class="float-right mt-2">
                                     <h4 class="font-weight-bold">Rs.872.04</h4>
                                 </div>
                                </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-3 border-qr">
                    <div class="text-center">
                        <img src="@/assets/img/qr2.png" width="150" height="auto">
                        <p class="text-gray mt-4 mb-0">BOOKING ID</p>
                        <h4 class="font-weight-bold">WSRSSS4</h4>
                    </div>
                </div>
            </div>
        </div>

        <div class="section-space"></div>
    </div>
</template>

<script>
export default {

}
</script>

<style>
    .ticket-tt {
        /* box-shadow: 1px 0px 15px 2px rgba(0, 0, 0, 0.76); */
        position: relative;
    }
    .text-gray {
        color: gray;
    }

    .seat-no {
        font-size: 18px;
        color: #4aba8e;
        font-weight: bold;
    }
    .border-dash {
        border-top: 2px dashed #e3e3e3;
    }
    .border-qr {
        border-left: 2px dashed #e3e3e3;
    }
    .cut1 {
        position: absolute;
        width: 50px;
        height: 50px;
        top: -8%;
        right: 23%;
        border-radius: 50%;
        background-color: #ffffff;
    }
    .cut2 {
        position: absolute;
        width: 50px;
        height: 50px;
        bottom: -8%;
        right: 23%;
        border-radius: 50%;
        background-color: #ffffff;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/ticket.vue